import {
  GET_USER_ACT_LIST_REQUESTED,
  GET_USER_ACT_LIST_FAILED,
  GET_USER_ACT_LIST_SUCCESS,
  CLEAR_USER_ACTS_LIST_ERROR,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const userActListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_ACT_LIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_ACT_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case GET_USER_ACT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case CLEAR_USER_ACTS_LIST_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default userActListReducer;
